export const transferConstants = {
  // Toggled Transfer Modals Constant
  TOGGLED_TRANSFER_MODAL: 'TOGGLED_TRANSFER_MODAL'
};
